import { useEffect, useState } from 'react';
import { getBrandList } from '../service/brandApi';

export interface BrandOption {
  value: number;
  label: string;
}

/**
 * 通用 Hook：品牌选项加载（从 cos_brand_cache 表获取）
 */
export function useBrandOptions() {
  const [brandOptions, setBrandOptions] = useState<BrandOption[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let mounted = true;
    setLoading(true);

    getBrandList({ pageNum: 1, pageSize: 1000, status: 0 })
      .then((response) => {
        if (!mounted) return;
        if (response.code === 1 && response.data?.list) {
          const validBrands = response.data.list.filter(
            (b) => b.id !== undefined && b.name !== undefined
          );
          const sortedBrands = [...validBrands].sort((a, b) => {
            if (a.sort !== undefined && b.sort !== undefined) {
              if (a.sort !== b.sort) return a.sort - b.sort;
            }
            return (a.id || 0) - (b.id || 0);
          });
          setBrandOptions(
            sortedBrands.map((b) => ({
              value: b.id,
              label: b.name || `品牌 ${b.id}`,
            }))
          );
        } else {
          setBrandOptions([]);
        }
      })
      .catch(() => {
        if (mounted) setBrandOptions([]);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, []);

  return { brandOptions, loading };
}

